import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { store } from "../../components/Store";
import { MakeMakeLive } from "../components/makemake-live";
import { ReadingPlans } from "../components/reading-plans";
import { Highlights } from "../components/highlights";

const AVAILABLE_EMBED_LANGUAGES = ["es", "en"];
const DEFAULT_EMBED_LANGUAGE = "es";

/**
 * Normaliza el idioma recibido por URL para los embeds.
 *
 * Si el parametro no corresponde a un idioma soportado, se usa espanol como
 * fallback para evitar renderizar componentes con un estado de idioma invalido.
 */
const getEmbedLanguage = (language) => {
	return AVAILABLE_EMBED_LANGUAGES.includes(language) ? language : DEFAULT_EMBED_LANGUAGE;
};

/**
 * Sincroniza el idioma de la ruta embed con el store global.
 *
 * Los componentes de Reading Resources usan `useLanguage` y
 * `useTranslationsById`, que leen el idioma desde `StateProvider`. Este wrapper
 * permite que rutas como `/embed/es/...` y `/embed/en/...` controlen ese idioma
 * sin montar la aplicacion completa.
 */
const EmbedLanguageWrapper = ({ children }) => {
	const { language } = useParams();
	const { dispatch } = useContext(store);
	const [ready, setReady] = useState(false);

	useEffect(() => {
		dispatch({
			type: "CHANGE_VALUE",
			property: "language",
			value: getEmbedLanguage(language),
		});
		setReady(true);
	}, [dispatch, language]);

	if (!ready) return null;

	return children;
};

/**
 * Version embebible del componente de planes de lectura.
 */
export const ReadingPlansEmbed = () => {
	return (
		<EmbedLanguageWrapper>
			<ReadingPlans />
		</EmbedLanguageWrapper>
	);
};

/**
 * Version embebible del componente MakeMake Live.
 */
export const MakeMakeLiveEmbed = () => {
	return (
		<EmbedLanguageWrapper>
			<MakeMakeLive />
			<Highlights/>
		</EmbedLanguageWrapper>
	);
};
